<template>
  <section id="overview">
    <!-- <v-col sm="12" lg="10" offset-lg="1"  xl="8" offset-xl="2"> -->
    <v-container class="font-weight-light">
      <v-row>
        <v-col cols="12" lg="10" xl="8" offset-lg="1" offset-xl="2">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              v-for="item in overviewItems"
              :key="item.name"
            >
              <v-card
                flat
                tile
                class="mx-auto"
                :class="$vuetify.breakpoint.mdAndUp ? 'pa-4' : ''"
              >
                <v-img
                  class="elevation-5"
                  :src="item.src"
                  :lazy-src="item.msrc"
                />
                <v-card-title class="pb-2">
                  <h1 class="text-h5 greend--text mb-4">{{ item.name }}</h1>
                </v-card-title>
                <v-card-text>
                  {{ item.text }}
                </v-card-text>
                <v-card-actions class="ml-2">
                  <v-btn outlined small color="greend" @click="navigate(item)">
                    {{ item.linkText }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      overviewItems: [
        {
          name: "Unser Betrieb",
          src: require("../../assets/overview_ernte.jpg"),
          msrc: require("../../assets/overview_ernte_80.jpg"),
          text:
            "Als Familienbetrieb bauen wir seit 1996 verschiedene Teekräuter an. Wir setzen dabei auf ein hohes Maß an Qualität und haben uns auf besondere Sorten spezialisiert.",
          target: "Betrieb",
          linkText: "weiterlesen"
        },
        {
          name: "Online-Shop",
          src: require("../../assets/overview_shop.jpg"),
          msrc: require("../../assets/overview_shop_80.jpg"),
          text: "Alle unsere Sorten finden Sie im Online-Shop.",
          target: "Shop",
          linkText: "zum Online-Shop"
        }
      ]
    };
  },
  methods: {
    navigate(item) {
      this.$ga.event("Navigation", item.name + " (von Startseite)", item.name +" auf Startseite");
      this.$router.push({name: item.target});
    }
  }
};
</script>
